import * as React from "react"
import * as styles from "./styles.module.scss"
import { brand } from "config/brand"

import LinkUnderline from "../LinkUnderline"
import pdf from "./pdf/better-mortgage-press-kit-102618.pdf"
import PressKitCoverFill from "../../icons/PressKitCoverFill"

const PressKit: React.FC = () => {
  return (
    <div className={styles.pressKit}>
      <a
        className={styles.link}
        href={pdf}
        download={`${brand.name} Press Kit`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className={styles.bookPerspective}>
          <figure className={styles.figure}>
            <PressKitCoverFill className={styles.image} />
          </figure>
        </div>
        <h4 className={styles.heading}>
          <LinkUnderline>{`Download the ${brand.name} Press Kit`}</LinkUnderline>
        </h4>
      </a>
    </div>
  )
}

export default PressKit
